'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validate = require('../validate');

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function onDelete(leftSelector, rightSelector, filter) {
  var safeLeftSelector = leftSelector || function (action) {
    return action.payload;
  };
  var safeRightSelector = rightSelector || function (item) {
    return item.id;
  };
  var safeFilter = filter || function (item, action) {
    return safeLeftSelector(action, item) !== safeRightSelector(item, action);
  };

  return (0, _validate2.default)({
    name: 'onDelete',
    realTarget: function realTarget(action) {
      return action.target;
    },
    do: function _do(action, state) {
      return state['' + action.target].filter(function (item) {
        return safeFilter(item, action);
      });
    }
  });
}

exports.default = onDelete;